import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { InmateBooking } from '@reliance/types/models/InmateBooking';

export const useInmateBookingsByInmateId = (inmateId: number | null | undefined) => {
  return useAsync<InmateBooking[]>(
    (currentInmateId?: number | null | undefined) => {
      const id = currentInmateId !== undefined ? currentInmateId : inmateId;
      if (!id) {
        return null;
      }
      return api
        .get<InmateBooking[]>(`/inmate/${id}/booking`)
        .then((response) => response.data ?? []);
    },
    inmateId === null ? [] : [inmateId]
  );
};
